function floatValue(value) {
    let result = 0;
    if (typeof value === "number" && !Number.isNaN(value)) {
        result = value;
    }
    else if (typeof value === "string") {
        result = Number.parseFloat(value);
    }
    return result;
}
function normalize(value) {
    const result = floatValue(value);
    return Number.parseFloat(result.toFixed(2));
}
function normalizeQuantity(value) {
    // to be robust against null/undefined/NaN
    if (value === null || value === undefined || Number.isNaN(value)) {
        return 0;
    }
    return Math.round(value);
}
/**
 * Parse raw text from a decimal-number input into a numeric value.
 *
 * Normalizes the French comma separator ("0,5") to a dot before parsing, so inputs work
 * with a French keyboard / iOS Safari where `<input type="number">` silently rejects
 * commas. Returns `null` for empty or non-numeric input so callers can distinguish "no
 * numeric value yet" from a legitimate 0 — typically used to keep a controlled input's
 * raw-string buffer while preserving the previously committed numeric state.
 */
function parseDecimalInput(rawValue) {
    const normalized = rawValue.replace(",", ".");
    const parsed = Number.parseFloat(normalized);
    return Number.isNaN(parsed) ? null : parsed;
}
export const numberService = {
    floatValue,
    normalizeQuantity,
    normalize,
    parseDecimalInput,
};
// TODO make a service here
//# sourceMappingURL=services.js.map